// src/pages/payments/pdfReceipt.js
import jsPDF from "jspdf";
import "jspdf-autotable";

const inr = (n) => `₹${Number(n || 0).toFixed(2)}`;

export function generatePaymentReceiptPDF(payment, company) {
  // A5 portrait (half A4)
  const doc = new jsPDF({ unit: "mm", format: "a5", orientation: "portrait" });
  const L = 12, R = 136; // content left/right bounds

  // Header
  doc.setFontSize(13);
  doc.setFont("helvetica", "bold");
  doc.text(company?.name || "Company Name", L, 16);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  if (company?.address) doc.text(String(company.address), L, 22);
  if (company?.gstin) doc.text(`GSTIN: ${company.gstin}`, L, 27);
  if (company?.phone) doc.text(`Phone: ${company.phone}`, L, 32);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("PAYMENT RECEIPT", R, 16, { align: "right" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(9);
  doc.text(`Receipt #: ${payment.receipt_no || "-"}`, R, 22, { align: "right" });
  doc.text(`Date: ${payment.payment_date || "-"}`, R, 27, { align: "right" });

  // Party + mode box
  doc.setDrawColor(200);
  doc.roundedRect(L, 36, R - L, 22, 2, 2);
  doc.setFontSize(9);

  doc.text("Received From", L + 3, 42);
  doc.setFont("helvetica", "bold");
  doc.text(payment.customer_name || "-", L + 35, 42);
  doc.setFont("helvetica", "normal");
  if (payment.customer_gst) doc.text(`GSTIN: ${payment.customer_gst}`, L + 35, 48);

  doc.text("Mode", L + 3, 54);
  doc.setFont("helvetica", "bold");
  doc.text(payment.mode || "-", L + 35, 54);
  doc.setFont("helvetica", "normal");
  doc.text("Reference", L + 80, 54);
  doc.setFont("helvetica", "bold");
  doc.text(payment.reference_no || "-", L + 102, 54);

  // Amount stripe
  doc.setFillColor(245, 247, 250);
  doc.roundedRect(L, 64, R - L, 14, 2, 2, "F");
  doc.setFontSize(10);
  doc.setFont("helvetica", "normal");
  doc.text("Amount", L + 3, 72);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text(inr(payment.amount), R - 3, 72, { align: "right" });

  // Narration
  let y = 84;
  if (payment.narration) {
    doc.setFontSize(9);
    doc.setFont("helvetica", "normal");
    doc.text("Narration:", L, y);
    doc.setFont("helvetica", "bold");
    doc.text(String(payment.narration), L + 20, y, { maxWidth: (R - L) });
    y += 8;
  }

  // Optional: Settlements against invoices
  if (Array.isArray(payment.settlements) && payment.settlements.length > 0) {
    doc.autoTable({
      startY: y,
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [235, 238, 242] },
      head: [["Invoice #", "Settled Amount"]],
      body: payment.settlements.map((s) => [
        s.invoice_number || "-",
        inr(s.settled_amount),
      ]),
      margin: { left: L, right: (210 / 2) - R + L },
      theme: "striped",
    });
    y = doc.lastAutoTable.finalY + 6;
  }

  // Footer / sign
  doc.setDrawColor(220);
  doc.line(L, y, R, y);
  y += 8;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(8);
  if (company?.email) doc.text(`Email: ${company.email}`, L, y);
  doc.text("This is a computer-generated receipt.", R, y, { align: "right" });

  y += 14;
  doc.setFontSize(9);
  doc.text("Authorised Signatory", R, y, { align: "right" });
  doc.line(R - 34, y + 1, R, y + 1);

  const fileName = `Receipt_${(payment.receipt_no || "NA").replace(/\s+/g, "")}.pdf`;
  doc.save(fileName);
}
